"use strict";

$ = jQuery;

var form = $('#model-offer-form');

function showError(error) {

  save_interest_lead_ajax();

  switch (error.code) {
    case error.PERMISSION_DENIED:
      console.log("User denied the request for Geolocation.");
      break;
    case error.POSITION_UNAVAILABLE:
      console.log("Location information is unavailable.");
      break;
    case error.TIMEOUT:
      console.log("The request to get user location timed out.");
      break;
    case error.UNKNOWN_ERROR:
      console.log("An unknown error occurred.");
      break;
  }
}

function save_interest_lead_ajax(position) {

  if ($('input[name=lgpd]').is(":checked")) {

    $('.warning-lgpd').css('display', 'none');

    var lgpd = [];

    $(this).parents('form:first').find('.lgpd-disclaimer').each(function () {
      lgpd.push({
        "text_disclaimer": $(this).text().replace(/\\n|\s{2,}/gm, ' ').trim(),
        "url_disclaimer": $(this).find('a').attr('href')
      });
    });
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_interest' }).then(function (grecaptchaToken) {
        $.ajax({
          url: ajaxHandler.url_leads + "/api/jornaldocarro/v1/receive-callback-interest",
          type: 'POST',
          data: {
            action: 'jc_save_interest_lead',
            nome: $('input[name=fullname]').val().trim(),
            email: $('input[name=email]').val().trim(),
            telefone: $('input[name=phone]').val().trim(),
            marca: $('input[name=brand]').val(),
            modelo: $('input[name=model]').val(),
            ano: $('input[name=year]').val(),
            oferta_id: $('input[name=offer_id]').val(),
            preco_min: $('input[name=min_price]').val().replace('.', '').replace(',', '.'),
            preco_max: $('input[name=max_price]').val().replace('.', '').replace(',', '.'),
            carroceria: $('input[name=bodywork]').val(),
            newsletter: $('input[name=newsletter]').is(":checked"),
            latitude: position ? position.coords.latitude : null,
            longitude: position ? position.coords.longitude : null,
            url_page: window.location.href,
            token: grecaptchaToken,
            lgpd_disclaimer: lgpd
          },
          success: function success(response) {
            if (response.data.message == "SUCCESS") {
              $('.text-success').css('display', 'block');
              $('button[name=interest-submit]').prop('disabled', false);
              form.slideUp();
              $('#form-header-text').text('Agradacemos por de monstrar interesse no(a) ' + $('input[name=brand]').val() + '\n' + $('input[name=model]').val());
              $('#form-subheader-text').text('Assim que uma oferta estiver disponível, entraremos em contato!');
              // send_to_new_lead_system();
            } else {
              $('.text-danger').css('display', 'block');
              $('button[name=interest-submit]').prop('disabled', false);
            }
          },
          error: function error(data) {
            $('.text-danger').css('display', 'block');
            $('button[name=interest-submit]').prop('disabled', false);
          }
        });
      });
    });
    // function send_to_new_lead_system() {
    //   grecaptcha.enterprise.ready(function() {
    //     grecaptcha.enterprise.execute(ajaxHandler.siteKey, {action: 'save_interest'}).then(function (grecaptchaToken) {
    //       $.ajax({
    //         url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/receive-callback-interest',
    //         type: 'POST',
    //         data: {
    //           action: 'jc_save_interest_lead',
    //           nome: $('input[name=fullname]').val().trim(),
    //           email: $('input[name=email]').val().trim(),
    //           telefone: $('input[name=phone]').val().trim(),
    //           marca: $('input[name=brand]').val(),
    //           modelo: $('input[name=model]').val(),
    //           ano: $('input[name=year]').val(),
    //           oferta_id: $('input[name=offer_id]').val(),
    //           preco_min: $('input[name=min_price]').val().replace('.', '').replace(',', '.'),
    //           preco_max: $('input[name=max_price]').val().replace('.', '').replace(',', '.'),
    //           carroceria: $('input[name=bodywork]').val(),
    //           newsletter: $('input[name=newsletter]').is(":checked"),
    //           latitude: position ? position.coords.latitude : null,
    //           longitude: position ? position.coords.longitude : null,
    //           url_page: window.location.href,
    //           token: grecaptchaToken,
    //           lgpd_disclaimer: lgpd
    //         },
    //         success: function (response) {
    //           if (response.data.message == "SUCCESS") {
    //             console.log('Lead enviado para o novo sistema');
    //           } else {
    //             console.log('Erro ao enviar lead para o novo sistema');
    //           }
    //         },
    //       });
    //     });
    //   });
    // }
  } else {
    $('.warning-lgpd').css('display', 'block');
    $('button[name=interest-submit]').prop('disabled', false);
  }
}

$(document).ready(function () {
  $('button[name=interest-submit]').on("click", function (event) {
    event.preventDefault();

    if (!validateEmail($(this).parents('form:first').find('input[name=email]').val().trim())) {
      $('.warning-email').css('display', 'block');
      return;
    }
    $('.text-success').css('display', 'none');
    $('.text-danger').css('display', 'none');
    $('.warning-email').css('display', 'none');
    $(this).attr('disabled', true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(save_interest_lead_ajax, showError);
    } else {
      save_interest_lead_ajax();
    }
  });

  var interestModal = $('#interest-form-modal');

  interestModal.on('click', '.jc-offer-back', function () {
    interestModal.modal('hide');
    offerForm.html('');
    offerModalLoader.show();
  });

  $(document).on('click', '#model-interest-cta, #model-interest-cta-footer-mobile', function (e) {
    e.preventDefault();
    interestModal.modal();
  });

  $('#interest-form-modal #card-list-interest-slider').on('click', 'a', function (e) {
    var offerID = $(e.currentTarget).data('offer-id');
    Offer_id = offerID;
    loadOffer(offerID, 'catalogo-0km', $('#offer-form-modal').find('.offer-form'));
    interestModal.modal('hide');
    e.preventDefault();
    var observer = new MutationObserver(completion_form_load);
    var targetNode = $('#offer-form-modal')[0];
    observer.observe(targetNode, { childList: true, subtree: true });
  });

  maskPhone($('.phone'));

  $('#edit-lead-data').on('click', function (event) {
    event.preventDefault();
    $('#user-data-show').collapse();
    $('.user-data-edit').collapse("show");
  });
});